import { createI18n } from "vue-i18n";
import axios from "axios";
import { ApplicationLocalizationConfigurationDto } from "@/api/model";

const i18n = createI18n({
  locale: "en",
  fallbackLocale: "en"
});

function setI18nLanguage(lang: string): string {
  i18n.global.locale = lang;
  axios.defaults.headers.common["Accept-Language"] = lang;
  return lang;
}

const setLocale = function (locale: ApplicationLocalizationConfigurationDto): void {
  const lang = locale.currentCulture?.cultureName || "en";
  i18n.global.setLocaleMessage(lang, locale.values || ({} as Record<string, string>));
  setI18nLanguage(lang);
};

export { i18n, setLocale, setI18nLanguage };
